import { render, staticRenderFns } from "./FoodCourtOnboardingModal.vue?vue&type=template&id=609252ce&scoped=true"
import script from "./FoodCourtOnboardingModal.vue?vue&type=script&lang=js"
export * from "./FoodCourtOnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtOnboardingModal.vue?vue&type=style&index=0&id=609252ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609252ce",
  null
  
)

export default component.exports